import { API, I18nt } from 'utils';
import { SearchOutlined } from '@ant-design/icons';

import cn from 'classnames';
import styles from './categoryView.module.less';
import { useAgendarCita } from 'pages/AgendarCita/AgendarCitaContext';
import { Category } from 'utils/interfaces';
import { Col, Row, Spin } from 'antd';
import { useEffect, useState } from 'react';

const PlaceView = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { categories, dispatch, selectedCategory } = useAgendarCita();
  const [search, setSearch] = useState('');

  const onClinicClick = (category: Category) => {
    dispatch({ type: 'setSelectedCategory', payload: { selectedCategory: category } });
  };

  const filteredCategories = categories.filter((category) => 
    category.nombreEspecialidad.toLocaleLowerCase().includes(search.toLocaleLowerCase())
  );

  useEffect(() => {
    setIsLoading(true);
    const getCategories = async () => {
      const { data } = await API.getEspecialistas();
      dispatch({ type: 'setCategoriesList', payload: { categories: data } });
      setIsLoading(false);
    };
    getCategories();

  }, []);

  const renderContent = () => {
    if (isLoading) {
      return (
        <div className={styles.spinCont}>
          <Spin />
        </div>
      );
    }

    return filteredCategories.map((place) => (
      <div
        key={place.idEspecialidad}
        className={cn(styles.place, {
          [styles.selected]:
            selectedCategory?.idEspecialidad ===
            place.idEspecialidad,
        })}
        onClick={() => onClinicClick(place)}
      >
        {place.nombreEspecialidad.toLocaleLowerCase()}
      </div>
    ));
  };

  return (
    <>
      <Row justify='center'>
        <Col xs={24} lg={12}>
          <div className={styles.filterContainer}>
            <input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              type='text'
              placeholder={I18nt('buscar_especialidad')}
            />
            <div className={styles.filterButton}>
              <SearchOutlined />
            </div>
          </div>
        </Col>
      </Row>
      <Row justify='center'>
        <Col xs={24} lg={12}>
          <section className={styles.placeSection}>
            <div className={styles.title}>{I18nt('seleccionar_categoria')}</div>
            <div className={styles.placesContainer}>
              {renderContent()}{ }
            </div>
          </section>
        </Col>
      </Row>
    </>
  );
};

export default PlaceView;
